import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { MainWalletSettingMutationKeys } from '../../../keys'
import {
	UpdateMainWalletSettingRequest,
	UpdateMainWalletSettingResponse,
} from '../../../type'
import { updateMainWalletSetting } from '../../services'

interface UseMutationUpdateMainWalletSettingProps {
	payload: UpdateMainWalletSettingRequest
}

export default function useMutationUpdateMainWalletSetting(
	props?: UseBaseMutationOptions<
		UpdateMainWalletSettingResponse,
		UseMutationUpdateMainWalletSettingProps
	>,
) {
	return useMutation({
		mutationKey: [MainWalletSettingMutationKeys.UpdateMainWalletSetting],
		mutationFn: (params) => updateMainWalletSetting(params.payload),
		...props,
	})
}
